import React from 'react';
import { Button } from '../ui/button';
import { Mail } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const CareersCTA = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-gray-950 to-gray-900">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-br from-blue-900/30 via-indigo-900/30 to-purple-900/30 rounded-3xl p-12 border border-blue-800 text-center relative overflow-hidden">
          {/* Glow effect */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.1),transparent_70%)]" />
          
          <div className="relative z-10">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to make an impact?
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
              Join our mission to transform how companies build and develop their teams. Your next adventure starts here.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
              <Button
                size="lg"
                onClick={openCalendly}
                className="bg-blue-600 hover:bg-blue-700 text-lg px-10 py-6"
              >
                Schedule a Conversation
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => window.location.href = '/contact'}
                className="border-2 border-gray-600 text-gray-200 hover:bg-gray-800 text-lg px-10 py-6"
              >
                <Mail className="w-5 h-5 mr-2" />
                Contact Us
              </Button>
            </div>

            <p className="text-sm text-gray-400">
              Questions? Email us at <a href="mailto:careers@traain.com" className="text-blue-400 hover:text-blue-300">careers@traain.com</a>
            </p>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default CareersCTA;
